import moment from 'moment';

export const getFormattedDate = ({ date }: any) => (
  moment
    .utc(date)
    .format('YYYY-MM-DD hh:mm:ss a')
)

export const format = (date: any) => {
  if (date) {
    const localDateFormatted = moment(date).local()
      .format('YYYY-MM-DD hh:mm:ss a')
    return localDateFormatted
  }
  return ''
}
